// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formstep .formulate-input .formulate-input-label{color:#000;font-size:80%!important;font-weight:400!important;line-height:1!important;margin-bottom:.5rem}.formstep .price_vat{color:#949aba;font-size:.8rem;line-height:1rem}.formstep .submit button{align-items:center;display:flex;justify-content:center;width:100%}@media(min-width:1260px){.formstep .sticky-container{height:100%!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
